import userStore from '@/stores/user';
import firstInitStore from '@/stores/firstInit';
import { progressRenderSkeletonScreen } from './firstScreenSkeleton';
import { FROM } from './constants';

export function renderFirstScreenSkeleton() {
  if (isBatchShowSkeleton()) {
    progressRenderSkeletonScreen();
  } else {
    firstInitStore.UPDATE_SHOW_SKELETON(true);
  }
}

// ShopeeFoodHC入口比较特殊，不支持chatbot但是会请求init session接口，但是卡片展示和chatbot差异太大，所以暂不支持新版骨架屏
export const isBatchShowSkeleton = () => ['batch_show', 'hide_typing_box'].includes((userStore.newABTestingConfigs as Record<string, any>).loading_page_batch_show) && firstInitStore.initStore.from !== FROM.ShopeeFoodHC;
// 只用于底部 inputArea 的控制
export const isShowInputAreaSkeleton = () => ['hide_typing_box'].includes((userStore.newABTestingConfigs as Record<string, any>).loading_page_batch_show) && firstInitStore.initStore.from !== FROM.ShopeeFoodHC;
